import React, {useEffect} from 'react';
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import {Alert, Stack, Tabs} from "@mui/material";
import {useSelector} from "react-redux";
import Grid2 from "@mui/material/Unstable_Grid2";
import DayTaskDetails from "../../components/Event/DayTaskDetails";
import Divider from "@mui/material/Divider";
import {useGetEventResourcesQuery} from "../../slices/apiSlice";
import {eventResourceCategory} from "../../util/standards-util";
import Link from "@mui/material/Link";
import config from "../../config";
import UploadWidget from "../../components/Upload/UploadWidget";

const Briefing = () => {
    const event = useSelector(state => state.session.event)
    const rules = useSelector(state => state.session.eventRules)
    const day = useSelector(state => state.session.day)
    const [files, setFiles] = React.useState({})
    const [dayId, setDayId] = React.useState(day?.i)

    const {data: fileData, refetch, isSuccess: isFilesSuccess} = useGetEventResourcesQuery({eventId:event?.id, dayId:day?.i},{skip: event === undefined || day === undefined})

    const onUploadComplete = () => {
        refetch()
    }

    useEffect(() => {
        setDayId(day?.i)
    }, [day]);

    useEffect(() => {
        if (isFilesSuccess){
            const files={
                lps:[],
                airspace:[],
                waypoints:[],
                documents:[],
            }

            fileData.forEach(f => {
                switch(f.category) {
                    case eventResourceCategory.LOCAL_PROCEDURES:
                        files.lps.push(f)
                        break;
                    case eventResourceCategory.AIRSPACE_FILE:
                        files.airspace.push(f)
                        break;
                    case eventResourceCategory.WAYPOINT_LIST:
                        files.waypoints.push(f)
                        break;
                    default:
                        files.documents.push(f)
                }
            })

            setFiles(files)
        }
    }, [isFilesSuccess,fileData]);

    return (
        <>
            <Grid2 container sx={{textAlign:'left',mb:'2em'}}>
                <Grid2 xs={12}>
                    <Box sx={{mb:'1em'}}>
                        <Typography variant={'h2'}>Task</Typography>
                    </Box>
                    {event && !day &&
                        <Alert severity={'info'}>No information yet</Alert>
                    }
                    {
                        day && day.k && rules &&
                        <Box mb={4}>
                            <DayTaskDetails day={day}/>
                        </Box>
                    }
                </Grid2>
                <Grid2 xs={12}>
                    <Divider/>
                    {files.airspace?.length>0 && false &&
                        <Box mt={4}>
                            <Typography variant={'h3'} component={'div'} mb={2}>Airspace files</Typography>
                            {files.airspace.map( f => (
                                <Link href={config.s3Url+f.objUri} key={f.id} target='_blank' sx={{textDecoration:'none'}}>
                                    <Box mt={1} sx={{display:'flex',alignItems:'center'}}>
                                        <Typography variant={'body1'} mr={2}>{f.filename}</Typography>
                                    </Box>
                                </Link>
                            ))}
                        </Box>
                    }
                    {files.waypoints?.length>0 && false &&
                        <Box mt={4}>
                            <Typography variant={'h3'} component={'div'} mb={2}>Waypoint files</Typography>
                        </Box>
                    }
                    {files.documents?.length>0 &&
                        <Box mt={4}>
                            <Typography variant={'h3'} component={'div'} mb={2}>Documents</Typography>
                            {files.documents.map( f => (
                                <Link href={config.s3Url+f.objUri} target='_blank' key={f.id} sx={{textDecoration:'none'}}>
                                    <Box mt={1} sx={{display:'flex',alignItems:'center'}}>
                                        <Typography variant={'body1'} mr={2}>{f.filename}</Typography>
                                    </Box>
                                </Link>
                            ))}
                        </Box>
                    }
                </Grid2>
            </Grid2>
            <UploadWidget onUploadComplete={onUploadComplete} dayId={dayId}/>
        </>
    );
};

export default Briefing;